import gql from 'graphql-tag'

export const GET_SETTING = gql`
  query {
    setting {
      id
      name
    }
  }
`

export default {
  GET_SETTING
}
